module.exports = {"id":"178031","name":"Paul Baysse","rating":"78","photo":"./data/images/photos/1/178031.png","club":{"name":"Girondins de BX","logo":"./data/images/clubs/GirondinsdeBX.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PaulBaysse0.json
// module id = 3392
// module chunks = 0